export default "__VITE_ASSET__DDu3NoXd__"